import React from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';

//Utils
import * as AuthUtils from './utils/auth';

//Components
// import BasePage from './pages/app/app';
// import SigninPage from './pages/signin/signin';
// import Page404 from './pages/exceptions/404';
import JoinRoom from './pages/joinRoom';
import ThankYou from './pages/thankYou';
import App from './pages/App';
import VideoRoom from './pages/videoRoom/videoRoom';
import ProviderLogin from './pages/providerLogin/providerLogin';
import MobileProviderLogin from './pages/providerLogin/mobile/mobileproviderLogin';
import ParentLogin from './pages/parentLogin/parentLogin';
import ParentWaiting from './pages/parentWaiting/parentWaiting';
import AppStateProvider, { useAppState } from './state';
// import HomeIndex from './pages/home';
import { ConnectOptions } from 'twilio-video';
import ErrorDialog from './components/ErrorDialog/ErrorDialog';
import { VideoProvider } from './components/VideoProvider';

const connectionOptions: ConnectOptions = {
	bandwidthProfile: {
	  video: {
		mode: 'collaboration',
		renderDimensions: {
		  high: { height: 1080, width: 1920 },
		  standard: { height: 90, width: 160 },
		  low: { height: 90, width: 160 },
		},
	  },
	},
	dominantSpeaker: true,
	maxAudioBitrate: 12000,
	networkQuality: { local: 1, remote: 1 },
	preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
  };


const VideoApp = () => {
	const { error, setError } = useAppState();
  
	return (
	  <VideoProvider options={connectionOptions} onError={setError}>
		<ErrorDialog dismissError={() => {
		  window.location.replace('/thank-you');
		  return setError(null)
		  }} error={error} />
		<App />
	  </VideoProvider>
	);
  };

const PrivateRoute = ({ component : Component, title,...rest }: any) => (
	<Route
		{...rest}
		/*eslint-disable no-return-assign*/
		render={props => (AuthUtils.isAuthCookiePresent() ? (
			<Component {...props} title={title} />
		) : (
			<Redirect to='/signin'/>
		))
		}
	/>
);

const routes = (

	<AppStateProvider>
		<Switch>
			{/* <Route exact path="/signin" component={SigninPage} /> */}
			<Route exact path="/videoroom/:therapistRoom" component={VideoRoom} />
			{/* <Route path="/providerlogin" component={ProviderLogin} />
			<Route path="/mobileproviderlogin" component={MobileProviderLogin} />
			<Route path="/parentlogin" component={ParentLogin} />
			<Route path="/parentwaiting" component={ParentWaiting} /> */}
			
			{/* <BasePage> */}
				{/* <Switch>
					<Route path="/*" component={Page404} />
				</Switch> */}
			{/* </BasePage> */}
			<Route exact path="/room" component={VideoApp} />
			<Route exact path="/" component={JoinRoom} />
			<Route exact path="/thank-you" component={ThankYou}/>

		</Switch>
	</AppStateProvider>
);

export default function configureRoutes() {
	return <BrowserRouter>{routes}</BrowserRouter>;
}
